<div class="n-oldalfej">
  <div>
    <h2>Bér adatszolgáltatás (08)</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }} · {{ idoszakNev }} · a 2608 havi bevallás adatai</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto">Év
    <select [ngModel]="aktiv.ev" (ngModelChange)="evValt(+$event)"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
  </label>
  <label class="ev-valaszto">Hónap
    <select [ngModel]="aktiv.ho" (ngModelChange)="hoValt(+$event)"><option *ngFor="let h of honapok" [ngValue]="h.value">{{ h.label }}</option></select>
  </label>
  <ion-button (click)="csv()" [disabled]="!adat?.mlapok?.length"><ion-icon slot="start" name="download-outline"></ion-icon>CSV</ion-button>
  <ion-button (click)="nyomtat()" [disabled]="!adat?.mlapok?.length"><ion-icon slot="start" name="print-outline"></ion-icon>Nyomtatás</ion-button>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet (Törzsadatok → Ügyfelek).</div>

<ng-container *ngIf="aktiv.ugyfelId && adat">
  <div class="n-panel as-info">
    <ion-icon name="information-circle-outline"></ion-icon>
    <div>
      <p><b>Elemzés és rögzítési segédlet – nem beküldhető bevallás.</b> A tárolt számfejtésekből mutatja a 2608 bevallás természetes
        személyenkénti (M-lap) értékeit és a főlap összesítőit, a 2608 nyomtatvány sorszámaival<ng-container *ngIf="adat.sablon_verzio">
        (betöltött NAV-sablon: XSD v{{ adat.sablon_verzio }}<ng-container *ngIf="adat.sablon_anyk_verzio">, lapkép: ÁNYK v{{ adat.sablon_anyk_verzio }}</ng-container>)</ng-container>.
        A beküldhető 2608-at a NAV-nyomtatványkitöltő készíti el ugyanezekből az adatokból: ott kell kiegészíteni, a NAV-ellenőrzéssel
        megmérni és gépi úton (M2M) beküldeni – vagy az XML-t az ONYA-ban betölteni.</p>
      <p>A nem munkaviszonyos jogviszonyok sora és foglalkoztatási kódja javaslat. KIVA-alany foglalkoztatónál a munkáltatói teher a
        KIVA-bevallásba tartozik, itt csak tájékoztató.</p>
    </div>
  </div>

  <div class="as-figyel" *ngIf="adat.figyelmeztetesek.length">
    <span class="cimke sarga" *ngFor="let f of adat.figyelmeztetesek">{{ f }}</span>
  </div>

  <div class="ata-kpi as-kpi">
    <div class="n-panel ata-k"><span>70. sor – levont SZJA-előleg</span><b>{{ adat.folap.szja_levont | number:'1.0-0' }} Ft</b>
      <small>74. sor: <b>{{ adat.folap.szja_kotelezettseg_ezer | number:'1.0-0' }}</b> ezer Ft (Σ 331.b)</small></div>
    <div class="n-panel ata-k"><span>103. sor – szociális hozzájárulási adó</span><b>{{ adat.folap.szocho | number:'1.0-0' }} Ft</b>
      <small>109. sor: <b>{{ adat.folap.szocho_kotelezettseg_ezer | number:'1.0-0' }}</b> ezer Ft (Σ 386.c)</small></div>
    <div class="n-panel ata-k"><span>160. sor – levont TB-járulék</span><b>{{ adat.folap.tb_jarulek | number:'1.0-0' }} Ft</b>
      <small><b>{{ adat.folap.tb_jarulek_ezer | number:'1.0-0' }}</b> ezer Ft (Σ 633.c) · családi j.kedv. {{ adat.folap.csaladi_jarulekkedvezmeny | number:'1.0-0' }}</small></div>
    <div class="n-panel ata-k"><span>Érintett természetes személyek</span><b>{{ adat.folap.termeszetes_szemelyek_szama }} fő</b>
      <small>ebből nyugdíj mellett foglalkoztatott: {{ adat.folap.nyugdijasok_szama }}</small></div>
    <div class="n-panel ata-k" *ngIf="vanKiva"><span>KIVA (tájékoztató, nem a 08 része)</span><b>{{ adat.folap.kiva | number:'1.0-0' }} Ft</b>
      <small>alap: {{ adat.folap.kiva_alap | number:'1.0-0' }} Ft</small></div>
  </div>

  <div class="tabla-wrap">
    <table class="n-racs">
      <thead><tr>
        <th *ngFor="let o of oszlopok" [class]="(o.num ? 'num ' : '') + (o.cs || '')">{{ o.c }}</th>
        <th>Hiányzó adat</th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let m of adat.mlapok" class="as-kattinthato" [class.kijelolt]="kijelolt === m" (click)="valaszt(m)" title="Részletek">
          <td *ngFor="let o of oszlopok" [class]="(o.num ? 'num ' : '') + (o.cs || '')">
            <ng-container [ngSwitch]="o.k">
              <b *ngSwitchCase="'nev'">{{ m.nev }}</b>
              <ng-container *ngSwitchCase="'jogviszony_kod'">{{ m.jogviszony_kod || '—' }}<span class="halvany" *ngIf="m.jogviszony_kod && !m.jogviszonyok[0]?.kod_biztos"> ?</span></ng-container>
              <ng-container *ngSwitchDefault>{{ szoveg(m, o) }}</ng-container>
            </ng-container>
          </td>
          <td>
            <span class="cimke sarga" *ngIf="m.hianyok.length" [title]="m.hianyok.join(', ')">{{ m.hianyok.length }} hiány</span>
            <span class="cimke zold" *ngIf="!m.hianyok.length">rendben</span>
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="adat.mlapok.length"><tr>
        <td *ngFor="let o of oszlopok; let i = index" [class]="(o.num ? 'num ' : '') + (o.cs || '')">{{ i === 0 ? 'Összesen' : (o.num && o.k !== 'napok' ? (osszeg(o) | number:'1.0-0') : '') }}</td>
        <td></td>
      </tr></tfoot>
    </table>
    <div class="ures" *ngIf="!adat.mlapok.length"><ion-icon name="document-outline"></ion-icon>{{ idoszakNev }} hónapra nincs számfejtés.</div>
  </div>

  <!-- A kijelölt dolgozó részletei -->
  <div class="as-reszlet" *ngIf="kijelolt as m">
    <div class="n-panel">
      <div class="n-panel-cim">{{ m.nev }} – jövedelmek (M-04) és SZJA (M-05)</div>
      <div class="as-kv">
        <ng-container *ngFor="let j of jovSorok(m)"><span>{{ j.sor }}. sor d)</span><b>{{ j.v | number:'1.0-0' }}</b></ng-container>
        <ng-container *ngIf="m.kedv_alap_anyak"><span>270. sor e) – anyák kedvezményének alapja</span><b>{{ m.kedv_alap_anyak | number:'1.0-0' }}</b></ng-container>
        <ng-container *ngIf="m.kedv_alap_fiatal"><span>270. sor f) – 25 év alattiak kedvezményének alapja</span><b>{{ m.kedv_alap_fiatal | number:'1.0-0' }}</b></ng-container>
        <ng-container *ngIf="m.nem_szja"><span>SZJA-mentes jogcím (nem kerül az M-04-re)</span><b>{{ m.nem_szja | number:'1.0-0' }}</b></ng-container>
        <span>324. sor b) – adóelőleg alapja</span><b>{{ m.szja_alap | number:'1.0-0' }}</b>
        <span>325. sor b) – bérnek minősülő</span><b>{{ m.berjovedelem | number:'1.0-0' }}</b>
        <span>330. / 331. sor b) – adóelőleg / levont</span><b>{{ m.szja | number:'1.0-0' }} / {{ m.szja_levont | number:'1.0-0' }}</b>
      </div>
    </div>
    <div class="n-panel">
      <div class="n-panel-cim">Kedvezmények (M-05)</div>
      <div class="as-kv" *ngIf="kedvSorok(m).length">
        <ng-container *ngFor="let k of kedvSorok(m)"><span>{{ k.sor }} {{ k.c }}</span><b>{{ k.v | number:'1.0-0' }}</b></ng-container>
        <span><b>323. sor b) – összesen</b></span><b>{{ m.kedvezmenyek.osszesen | number:'1.0-0' }}</b>
      </div>
      <div class="halvany" *ngIf="!kedvSorok(m).length">Nincs érvényesített kedvezmény.</div>
    </div>
    <div class="n-panel">
      <div class="n-panel-cim">Jogviszonyok (M-08 / M-09-02)</div>
      <div *ngFor="let j of m.jogviszonyok" class="as-kv">
        <span>{{ j.tipus_nev }}</span><b>kód {{ j.foglalkoztatas_minosege_kod || '—' }}{{ j.kod_biztos ? '' : ' (javaslat)' }}</b>
        <span>Biztosítás a hónapban</span><b>{{ j.tol }} – {{ j.ig }} · {{ j.napok }} nap</b>
        <span>FEOR · heti munkaidő</span><b>{{ j.feor || '—' }} · {{ j.heti_oraszam || '—' }} óra</b>
        <span>626 / 629 / 630 / 633</span><b>{{ j.tb_alap | number:'1.0-0' }} / {{ j.tb | number:'1.0-0' }} / {{ j.csaladi_jarulekkedvezmeny | number:'1.0-0' }} / {{ j.tb_fizetendo | number:'1.0-0' }}</b>
      </div>
      <div class="as-kv" *ngIf="m.szocho || m.szocho_alap">
        <span>385. / 386. sor c) – szocho alap / adó (M-07)</span><b>{{ m.szocho_alap | number:'1.0-0' }} / {{ m.szocho | number:'1.0-0' }}</b>
      </div>
      <p class="halvany" *ngIf="m.hianyok.length">Hiányzó törzsadat: {{ m.hianyok.join(', ') }}</p>
    </div>
    <div class="n-panel">
      <div class="n-panel-cim">Sorkódok (a nyomtatványkitöltőnek)</div>
      <div class="as-kv">
        <ng-container *ngFor="let s of sorKodok(m)"><span class="as-sorkod">{{ s[0] }}</span><b>{{ s[1] | number:'1.0-0' }}</b></ng-container>
      </div>
    </div>
  </div>
</ng-container>
